const hours = [
  { day: "Monday", time: "7AM – 8PM" },
  { day: "Tuesday", time: "7AM – 8PM" },
  { day: "Wednesday", time: "7AM – 8PM" },
  { day: "Thursday", time: "7AM – 8PM" },
  { day: "Friday", time: "7AM – 8PM" },
  { day: "Saturday", time: "7AM – 8PM" },
  { day: "Sunday", time: "7AM – 8PM" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-gradient-to-br from-primary-800 via-primary-700 to-primary-900 text-background-50">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {/* Map */}
            <div className="space-y-4">
              <div className="rounded-lg overflow-hidden w-full h-48 md:h-56 bg-background-200">
                <iframe
                  src="https://maps.google.com/maps?q=293+S+Kendall+St+Norwood+NC+28128&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="NW Trucking of NC LLC Location"
                  aria-label="Google Map showing NW Trucking of NC LLC location"
                />
              </div>
            </div>

            {/* Company Info */}
            <div className="space-y-4">
              <h5 className="text-base font-bold text-background-50">
                NW Trucking
                <br />
                of NC LLC
              </h5>
              <div className="space-y-3 text-sm">
                <p className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="fas fa-phone text-xs" />
                  </div>
                  <a
                    href="tel:2295087357"
                    className="hover:text-primary-300 transition-colors"
                  >
                    (229) 508-7357
                  </a>
                </p>
                <p className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="fas fa-map-marker-alt text-xs" />
                  </div>
                  <a
                    href="https://maps.google.com/maps?q=293+S+Kendall+St+Norwood+NC+28128"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary-300 transition-colors"
                  >
                    293 S Kendall St, Norwood, NC 28128
                  </a>
                </p>
                <p className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="fas fa-envelope-open-text text-xs" />
                  </div>
                  <a
                    href="mailto:info@nwtrucking.us"
                    className="hover:text-primary-300 transition-colors"
                  >
                    info@nwtrucking.us
                  </a>
                </p>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="space-y-4">
              <h5 className="text-base font-bold text-background-50">
                Opening hours
              </h5>
              <div className="space-y-2 text-sm">
                {hours.map((item) => (
                  <p key={item.day} className="text-background-200">
                    {item.day}{" "}
                    <span className="text-background-50">{item.time}</span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="w-full border-t border-background-200/30">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-4">
          <p className="text-xs text-center text-background-300">
            &copy; 2026 NW Trucking of NC LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}